// Core
import React from 'react';
import PropTypes from 'prop-types';

// MUI
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import RightArrow from '@material-ui/icons/ChevronRight';

// Data
import { useDispatch } from 'react-redux';

// Custom
import tracker from 'utils/tracker';
import { hardCodedInstitutions } from './dataHardcode';
import { institutionSelected } from '../actions';

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: 428,
    display: 'flex',
    justifyContent: 'space-between',
    padding: 24,
  },
  leftSide: {
    flexGrow: 1,
    width: 180,
    marginBottom: 76,
    paddingRight: 20,
    borderRight: `1px solid ${theme.palette.greyScale[5]}`,
    display: 'flex',
    flexDirection: 'column',
  },
  rightSide: {
    flexGrow: 1,
    flexBasis: 546,
    paddingLeft: 16,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  iconButton: {
    marginTop: 24,
    height: 92,
    width: 160,
    padding: 0,
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      boxShadow: `0 0 5px 1px ${theme.applyOpacityToHex(theme.palette.greyScale[0], 0.3)}`,
    },
  },
  iconImg: {
    width: 160,
    height: 92,
  },
  listButton: {
    minHeight: 76,
    width: '100%',
    borderBottom: `1px solid ${theme.palette.greyScale[4]}`,
    textTransform: 'none',
    padding: '12px 8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonText: {
    textAlign: 'left',
    flexGrow: 1,
  },
  bold: {
    fontWeight: 500,
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  listWrapper: {
    width: '100%',
    flexGrow: 1,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}));

// const bidList = ['7492', '1236', '20754', '54870', '17410', '66070', '7460', '15496', '66065',
//   '66064', '54885', '66066', '14587', '54789', '7463', '66063', '5236', '66161', '66071'];

const handleSelect = (institution, trackingProperties, dispatch) => {
  dispatch(institutionSelected(institution?.id));
  tracker.track(tracker.events.addFISelect, {
    ...trackingProperties,
    institution_id: institution.id,
    institution_name: institution.name,
  });
};

export default function CapOne (props) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const { trackingProperties } = props;

  const first = hardCodedInstitutions[0];
  const second = hardCodedInstitutions[1];

  return (
    <div className={classes.root}>
      <div className={classes.leftSide}>
        <Typography variant="body1" className={classes.bold}>
          Pick From Popular
        </Typography>

        <Button
          className={classes.iconButton}
          onClick={() => handleSelect(first, { trackingProperties, selected_by: 'icon' }, dispatch)}
        >
          <img src={first?.logoUrl} alt="CapOne" className={classes.iconImg} />
        </Button>

        <Button
          className={classes.iconButton}
          onClick={() => handleSelect(second, { trackingProperties, selected_by: 'icon' }, dispatch)}
        >
          <img src={second?.logoUrl} alt="CapOne360" className={classes.iconImg} />
        </Button>
      </div>

      <div className={classes.rightSide}>
        <Typography variant="body1" className={classes.bold}>
          Choose from others
        </Typography>

        <div className={classes.listWrapper}>
          {hardCodedInstitutions.map((bank) => (
            <Button
              className={classes.listButton}
              key={bank.bid}
              onClick={() => handleSelect(bank, { trackingProperties, selected_by: 'list' }, dispatch)}
            >
              <div className={classes.stack}>
                <Typography variant="body1" className={classes.buttonText}>
                  {bank.name}
                </Typography>
                <Typography variant="body2" className={classes.buttonText} noWrap>
                  {bank.url}
                </Typography>
              </div>

              <RightArrow />
            </Button>
          ))}
        </div>
      </div>
    </div>)
}

CapOne.propTypes = {
  trackingProperties: PropTypes.object,
};

